import {
  Box,
  createTheme,
  Grid,
  IconButton,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AthleticLogo,
  BTLogo,
  FlagMedical,
  FlagSports,
  IconDown,
  IconGmail,
  IconLeft,
  IconRight,
  IconWhatsapp,
} from "assets/icons/config";
import ListProductProposalMobil from "./ListProductProposalMobil";
import FooterProposal from "./FooterProposal";
import { useEffect, useState } from "react";
import {
  servicesComplementarySports,
  servicesMedicalSports,
  servicesVirtualSports,
} from "../options";
import { useSwipeable } from "react-swipeable";
import { postProposalsLogs } from "services/payments";
import ListProductRecommended from "./ListProductRecommended";

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Gotham medium', sans-serif !important",
        },
        h5: {
          textTransform: "none",
          fontWeight: 600,
        },
        h4: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});

const ProposalMobil = ({
  currentBrand,
  data,
  brand,
  uuid,
  productRecommended,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [card, setCard] = useState(0);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [text, setText] = useState(
    "En estos momentos, la funcionalidad está deshabilitada."
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (card < 2) {
        handleChangeArrow("right");
      } else {
        setCard(0);
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [card]);

  const handlePostProposalLogs = (actionType) => {
    const data = {
      proposal_uuid: uuid,
      brand_id: currentBrand,
      action_type: actionType,
      device_type: "mobile",
    };
    postProposalsLogs(data)
      .then(({ data }) => {
        console.log(data);
      })
      .catch(({ err }) => {
        console.log(err);
      });
  };

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeCard = (card) => {
    setCard(card);
  };

  const handleChangeArrow = (directions) => {
    if (directions == "right") {
      if (card < 2) {
        setCard(card + 1);
      } else {
        setCard(0);
      }
    }
    if (directions == "left") {
      if (card > 0) {
        setCard(card - 1);
      } else {
        setCard(2);
      }
    }
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => handleChangeArrow("right"),
    onSwipedRight: () => handleChangeArrow("left"),
  });

  const handleClickGmail = () => {
    handlePostProposalLogs("touch email");
    const email = data.email_user;
    const subject = `Cotización Bodytech N°${data.proposal_id} - ${data.user_proposal.name}`;
    const body =
      "Buen día, el/los planes en los que estoy interesado(a) para que me envíen el link de pago, son: ";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, "_blank");
  };

  const handleClickWhatsapp = () => {
    handlePostProposalLogs("touch whatsapp");
    setOpenTooltip(true);
    setTimeout(() => {
      setOpenTooltip(false);
    }, 2000);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box py={{ xs: 2, md: 6 }} px={{ xs: 3, md: 12 }}>
        <Grid
          xs={3}
          container
          justifyContent={{ xs: "flex-start", md: "flex-start" }}
        >
          {["1", "3"].includes(currentBrand) ? (
            <BTLogo width={64} height={24} />
          ) : (
            <AthleticLogo />
          )}
        </Grid>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-end"}
        >
          <Typography variant="h4" fontSize={"25px"} marginTop={"30px"}>
            Tu cotización{" "}
          </Typography>
          <b style={{ fontSize: "20px", color: "#E7662B" }}>
            N° {data.proposal_id}
          </b>
        </Box>
        <Box width={"max-content"} display={"flex"}>
          <Typography
            fontSize={"12px"}
            color={"#a4a4a4"}
            display={"flex"}
            alignItems={"center"}
          >
            {data.date}
          </Typography>
        </Box>

        <Typography fontSize={"12px"} margin={"8px 0 30px 0"}>
          Aquí está toda la información sobre tu plan Bodytech
        </Typography>
        <Box>
          <Box padding={"12px"}>
            <Box display={"flex"} justifyContent={"space-between"}>
              <Typography variant="h5" color={"#626160"} fontSize={"15px"}>
                Asesor
              </Typography>
              <Box display={"flex"}>
                <Tooltip title={text} arrow placement="top" open={openTooltip}>
                  <Box marginRight={"20px"} onClick={handleClickWhatsapp}>
                    <IconWhatsapp />
                  </Box>
                </Tooltip>
                <Box onClick={handleClickGmail}>
                  <IconGmail />
                </Box>
              </Box>
            </Box>
            <hr style={{ margin: "8px 0", width: "100%" }}></hr>
            <Box display={"flex"}>
              <Typography
                fontSize={"12px"}
                color={"#a4a4a4"}
                display={"flex"}
                alignItems={"center"}
                marginRight={"10px"}
                width={"60px"}
              >
                Nombre
              </Typography>
              <p
                style={{
                  fontSize: "15px",
                  color: "#3C3C3B",
                  margin: "0px",
                  fontWeight: "500",
                }}
              >
                {data.name_user}
              </p>
            </Box>
            <Box display={"flex"}>
              <Typography
                fontSize={"12px"}
                color={"#a4a4a4"}
                display={"flex"}
                alignItems={"center"}
                marginRight={"10px"}
                width={"60px"}
              >
                Sede
              </Typography>
              <p
                style={{
                  fontSize: "15px",
                  color: "#3C3C3B",
                  margin: "0px",
                  fontWeight: "500",
                }}
              >
                {data.venue_name}
              </p>
            </Box>
            <Box display={"flex"}>
              <Typography
                fontSize={"12px"}
                color={"#a4a4a4"}
                display={"flex"}
                alignItems={"center"}
                marginRight={"10px"}
                width={"60px"}
              >
                Contacto
              </Typography>
              <p
                style={{
                  fontSize: "15px",
                  color: "#3C3C3B",
                  margin: "0px",
                  fontWeight: "500",
                }}
              >
                {data.phone_user}
              </p>
            </Box>
          </Box>
        </Box>
        <Box py={{ xs: 3, md: 2 }}>
          <Box width={"100%"} height={"100%"} padding={"12px"}>
            <Box>
              <Typography variant="h5" color={"#626160"} fontSize={"15px"}>
                Afiliado
              </Typography>
            </Box>
            <hr style={{ margin: "8px 0" }}></hr>
            <Box>
              <Box display={"flex"}>
                <Typography
                  fontSize={"12px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                  width={"70px"}
                >
                  Nombre
                </Typography>
                <p
                  style={{
                    fontSize: "15px",
                    color: "#3C3C3B",
                    margin: "0px",
                    fontWeight: "500",
                  }}
                >
                  {data.user_proposal.name}
                </p>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {data.info_products.sports_products.length > 0 && (
        <Box
          style={{
            borderTop: "1px solid #E7662B",
            // borderBottom: "1px solid #E7662B",
            marginBottom: "16px",
          }}
        >
          <Box
            display={"flex"}
            alignItems={"flex-end"}
            justifyContent={"space-between"}
            padding={"0 24px"}
          >
            <p style={{ margin: "20px 0 0 0" }}>
              <b>Servicios Médicos Deportivos</b>
            </p>
            {/* <FlagSports /> */}
          </Box>
          <Box padding={"8px 24px"}>
            {data.info_products.sports_products.map((item, index) => {
              return (
                <Box marginBottom={"25px"}>
                  <ListProductProposalMobil
                    index={index}
                    item={item}
                    brand={brand}
                    handleChange={handleChangeExpanded}
                    expanded={expanded}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
      {data.info_products.others_products.length > 0 && (
        <Box
          style={{
            borderTop: "1px solid #E7662B",
            marginBottom: "16px",
          }}
        >
          <Box
            display={"flex"}
            alignItems={"flex-end"}
            justifyContent={"space-between"}
            padding={"0 24px"}
          >
            <p style={{ margin: "20px 0 0 0" }}>
              <b>Servicios Médicos Complementarios</b>
            </p>
            {/* <FlagMedical /> */}
          </Box>
          <Box padding={"8px 24px"}>
            {data.info_products.others_products.map((item, index) => {
              return (
                <Box marginBottom={"25px"}>
                  <ListProductProposalMobil
                    index={index}
                    item={item}
                    brand={brand}
                    handleChange={handleChangeExpanded}
                    expanded={expanded}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
      <Box
        style={{
          borderTop: "1px solid #E7662B",
          borderBottom: "1px solid #E7662B",
          marginBottom: "16px",
        }}
      >
        <Box
          display={"flex"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          padding={"0 24px"}
        >
          <p style={{ margin: "20px 0 0 0" }}>
            <b> Productos que te podrian interesar</b>
          </p>
          {/* <FlagMedical /> */}
        </Box>
        <Box padding={"8px 24px"}>
          {productRecommended.length > 0 && (
            <>
              <Grid
                container
                spacing={2}
                py={{ xs: 1, md: 2 }}
                px={{ xs: 3, md: 12 }}
              >
                <ListProductRecommended
                  isMobile={true}
                  brand={brand}
                  productRecommended={productRecommended}
                />
              </Grid>
            </>
          )}
        </Box>
      </Box>

      <Box py={{ xs: 2, md: 6 }} px={{ xs: 3, md: 12 }}>
        <Typography
          variant="h5"
          fontSize={"16px"}
          style={{ textTransform: "none" }}
        >
          Afiliándote en Bodytech obtienes
        </Typography>
        <Box {...handlers}>
          {card == 0 && (
            <Grid
              container
              spacing={0.5}
              border={"1px solid #F5F4F4"}
              backgroundColor={"#FBFBFB"}
              borderRadius={"10px"}
              marginTop={"25px"}
              padding={"20px 20px"}
            >
              <Grid item xs={12} marginBottom={"6px"}>
                <Typography
                  variant="h5"
                  fontSize={"17px"}
                  style={{ textTransform: "none" }}
                >
                  Servicios Médicos Deportivos
                </Typography>
              </Grid>
              {servicesMedicalSports(brand, 32).map((item) => {
                return (
                  <Grid item xs={6}>
                    <Box display={"flex"} alignItems={"center"}>
                      <span>{item.icon}</span>
                      <Typography fontSize={"10px"} marginLeft={"6px"}>
                        {item.text}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}
          {card == 1 && (
            <Grid
              container
              spacing={0.5}
              border={"1px solid #F5F4F4"}
              backgroundColor={"#FBFBFB"}
              borderRadius={"10px"}
              marginTop={"25px"}
              padding={"20px 20px"}
            >
              <Grid item xs={12} marginBottom={"6px"}>
                <Typography
                  variant="h5"
                  fontSize={"17px"}
                  style={{ textTransform: "none" }}
                >
                  Servicios Médicos Complementarios
                </Typography>
              </Grid>
              {servicesComplementarySports(brand, 32).map((item) => {
                return (
                  <Grid item xs={6}>
                    <Box display={"flex"} alignItems={"center"}>
                      <span>{item.icon}</span>
                      <Typography fontSize={"10px"} marginLeft={"6px"}>
                        {item.text}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}
          {card == 2 && (
            <Grid
              container
              spacing={0.5}
              border={"1px solid #F5F4F4"}
              backgroundColor={"#FBFBFB"}
              borderRadius={"10px"}
              marginTop={"25px"}
              padding={"20px 20px"}
            >
              <Grid item xs={12} marginBottom={"6px"}>
                <Typography
                  variant="h5"
                  fontSize={"17px"}
                  style={{ textTransform: "none" }}
                >
                  Servicios médicos deportivos
                </Typography>
              </Grid>
              {servicesVirtualSports(brand, 32).map((item) => {
                return (
                  <Grid item xs={6}>
                    <Box display={"flex"} alignItems={"center"}>
                      <span>{item.icon}</span>
                      <Typography fontSize={"10px"} marginLeft={"6px"}>
                        {item.text}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={0.8}
        >
          <IconButton onClick={() => handleChangeArrow("left")}>
            <IconLeft size={"18px"} />
          </IconButton>
          {[...Array(3)].map((_, index) => (
            <IconButton
              key={index}
              disableRipple
              disableFocusRipple
              sx={{
                backgroundColor: card == index ? "#fd7e14" : "white",
                borderRadius: "50%",
                border: "1px solid #fd7e14",
                padding: "4px",
              }}
              onClick={() => handleChangeCard(index)}
            />
          ))}
          <IconButton onClick={() => handleChangeArrow("right")}>
            <IconRight size={"18px"} />
          </IconButton>
        </Box>
        {/* <FooterProposal brand={brand} /> */}
      </Box>
    </ThemeProvider>
  );
};

export default ProposalMobil;
